"use strict";
/**
 * DataEditButtons
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrudeAction = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../store/crude/crude.selector");
var ButtonComponent_1 = __importDefault(require("../../shared/components/FormComponents/ButtonComponent"));
var react_i18next_1 = require("react-i18next");
var styles_1 = require("@mui/styles");
var material_1 = require("@mui/material");
var commonTypes_1 = require("../../shared/types/commonTypes");
var Save_1 = __importDefault(require("@mui/icons-material/Save"));
var ArrowBackIosNew_1 = __importDefault(require("@mui/icons-material/ArrowBackIosNew"));
var Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
var DeleteForever_1 = __importDefault(require("@mui/icons-material/DeleteForever"));
var Backspace_1 = __importDefault(require("@mui/icons-material/Backspace"));
var Clear_1 = __importDefault(require("@mui/icons-material/Clear"));
var HighlightOff_1 = __importDefault(require("@mui/icons-material/HighlightOff"));
var CrudeAction;
(function (CrudeAction) {
    CrudeAction["delete"] = "delete";
    CrudeAction["back"] = "back";
    CrudeAction["edit"] = "edit";
    CrudeAction["create"] = "create";
    CrudeAction["cancel"] = "cancel";
})(CrudeAction = exports.CrudeAction || (exports.CrudeAction = {}));
var useStyles = styles_1.makeStyles(function (theme) { return ({
    button: {
        display: 'inline-block',
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    mobileButton: {
        border: '1px solid',
        borderRadius: '4px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: '48px',
    },
}); });
var DataEditButtons = function (props) {
    var _a, _b, _c, _d, _e;
    var t = react_i18next_1.useTranslation().t;
    var classes = useStyles();
    var entity = props.entity;
    var theme = react_redux_1.useSelector(crude_selector_1.getTheme);
    var screenDesign = react_redux_1.useSelector(crude_selector_1.getScreenDesign);
    var crudeSchema = react_redux_1.useSelector(crude_selector_1.getCrudeSchema);
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var entitySchema = crudeSchema && crudeSchema.find(function (entitySchema) { return entitySchema.name === entity; });
    var hideBackButton = props.hideBackButton || false;
    var id = !(props.id === 'new') && props.id;
    var _f = react_1.useState(props.buttonActivation ||
        {
            delete: true,
            edit: true,
            create: true,
        }), buttonActivation = _f[0], setButtonActivation = _f[1];
    react_1.useEffect(function () {
        props.buttonActivation && setButtonActivation(props.buttonActivation);
    }, [props.buttonActivation]);
    var getDeleteIcon = function () {
        var _a, _b, _c, _d, _e;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            ((_a = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _a === void 0 ? void 0 : _a.deleteIcon) === 'delete' &&
                react_1.default.createElement(Delete_1.default, { color: buttonActivation.delete ? 'secondary' : 'disabled' }),
            ((_b = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _b === void 0 ? void 0 : _b.deleteIcon) === 'deleteForever' &&
                react_1.default.createElement(DeleteForever_1.default, { color: 'secondary' }),
            ((_c = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _c === void 0 ? void 0 : _c.deleteIcon) === 'backspace' &&
                react_1.default.createElement(Backspace_1.default, { color: buttonActivation.delete ? 'secondary' : 'disabled' }),
            ((_d = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _d === void 0 ? void 0 : _d.deleteIcon) === 'clear' &&
                react_1.default.createElement(Clear_1.default, null),
            ((_e = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _e === void 0 ? void 0 : _e.deleteIcon) === 'highlightOff' &&
                react_1.default.createElement(HighlightOff_1.default, { color: buttonActivation.delete ? 'secondary' : 'disabled' })));
    };
    var instancePermission = (_a = props.data) === null || _a === void 0 ? void 0 : _a.instancePermissions;
    var showDeleteButton = instancePermission && instancePermission[props.id] ? instancePermission[props.id].entity.deleteAllowed : (entitySchema && id ? entitySchema.entityPermissions.deleteAllowedByDefault : false);
    var showEditButton = instancePermission && instancePermission[props.id] ? instancePermission[props.id].entity.updateAllowed : (entitySchema && id ? entitySchema.entityPermissions.updateAllowedByDefault : false);
    var showCreateButton = entitySchema && !id ? entitySchema.entityPermissions.createAllowed : false;
    var showBackButton = !hideBackButton;
    return (react_1.default.createElement(material_1.Box, { sx: { display: 'flex', justifyContent: screenDesign === commonTypes_1.ScreenDesign.mobile ? 'space-between' : 'flex-start', width: '100%' } },
        !showBackButton &&
            react_1.default.createElement(material_1.Box, { className: classes.button },
                react_1.default.createElement(react_1.default.Fragment, null, screenDesign === commonTypes_1.ScreenDesign.mobile ? (react_1.default.createElement(material_1.Box, { className: classes.mobileButton, sx: { borderColor: theme.palette.secondary.main } },
                    react_1.default.createElement(material_1.IconButton, { onClick: function () { return props.onClick && props.onClick(props.entity, CrudeAction.cancel); } },
                        react_1.default.createElement(ArrowBackIosNew_1.default, { color: 'secondary' }))))
                    : (react_1.default.createElement(ButtonComponent_1.default, { variant: (_b = appLayout.button) === null || _b === void 0 ? void 0 : _b.type, color: 'secondary', onClick: function () { return props.onClick && props.onClick(props.entity, CrudeAction.cancel); }, text: t('crude:cancel') })))),
        showBackButton &&
            react_1.default.createElement(material_1.Box, { className: classes.button },
                react_1.default.createElement(react_1.default.Fragment, null, screenDesign === commonTypes_1.ScreenDesign.mobile ? (react_1.default.createElement(material_1.Box, { className: classes.mobileButton, sx: { borderColor: theme.palette.secondary.main } },
                    react_1.default.createElement(material_1.IconButton, { onClick: function () { return props.onClick && props.onClick(props.entity, CrudeAction.back); } },
                        react_1.default.createElement(ArrowBackIosNew_1.default, { color: 'secondary' }))))
                    : (react_1.default.createElement(ButtonComponent_1.default, { variant: (_c = appLayout.button) === null || _c === void 0 ? void 0 : _c.type, color: 'secondary', onClick: function () { return props.onClick && props.onClick(props.entity, CrudeAction.back); }, text: t('crude:back') })))),
        react_1.default.createElement(material_1.Box, null,
            showDeleteButton && id &&
                react_1.default.createElement(material_1.Box, { className: classes.button },
                    react_1.default.createElement(react_1.default.Fragment, null, screenDesign === commonTypes_1.ScreenDesign.mobile ? (react_1.default.createElement(material_1.Box, { className: classes.mobileButton, sx: { borderColor: buttonActivation.delete ? theme.palette.secondary.main : theme.palette.grey.A400 } },
                        react_1.default.createElement(material_1.IconButton, { onClick: function () {
                                setButtonActivation(__assign(__assign({}, buttonActivation), { delete: false }));
                                props.onClick && props.onClick(props.entity, CrudeAction.delete, id);
                            } }, getDeleteIcon())))
                        : (react_1.default.createElement(ButtonComponent_1.default, { color: 'secondary', variant: (_d = appLayout.button) === null || _d === void 0 ? void 0 : _d.type, disabled: !buttonActivation.delete, onClick: function () {
                                setButtonActivation(__assign(__assign({}, buttonActivation), { delete: false }));
                                props.onClick && props.onClick(props.entity, CrudeAction.delete, id);
                            }, text: t('crude:delete') })))),
            showEditButton && id &&
                react_1.default.createElement(material_1.Box, { className: classes.button, sx: { marginRight: '0px' } },
                    react_1.default.createElement(react_1.default.Fragment, null, screenDesign === commonTypes_1.ScreenDesign.mobile ? (react_1.default.createElement(material_1.Box, { className: classes.mobileButton, sx: { borderColor: buttonActivation.edit ? theme.palette.primary.main : theme.palette.grey.A400 } },
                        react_1.default.createElement(material_1.IconButton, { onClick: function () {
                                setButtonActivation(__assign(__assign({}, buttonActivation), { edit: false }));
                                props.onClick && props.onClick(props.entity, CrudeAction.edit, id);
                            } },
                            react_1.default.createElement(Save_1.default, { color: buttonActivation.edit ? 'primary' : 'disabled' }))))
                        : (react_1.default.createElement(ButtonComponent_1.default, { color: 'primary', variant: (_e = appLayout.button) === null || _e === void 0 ? void 0 : _e.type, disabled: !buttonActivation.edit, onClick: function () {
                                setButtonActivation(__assign(__assign({}, buttonActivation), { edit: false }));
                                props.onClick && props.onClick(props.entity, CrudeAction.edit, id);
                            }, text: t('crude:save') })))),
            showCreateButton &&
                react_1.default.createElement(material_1.Box, { className: classes.button, sx: { marginRight: '0px' } },
                    react_1.default.createElement(react_1.default.Fragment, null, screenDesign === commonTypes_1.ScreenDesign.mobile ? (react_1.default.createElement(material_1.Box, { className: classes.mobileButton, sx: {
                            borderColor: buttonActivation.create ? theme.palette.primary.main : theme.palette.grey.A400,
                        } },
                        react_1.default.createElement(material_1.IconButton, { onClick: function () { return props.onClick && props.onClick(props.entity, CrudeAction.create); } },
                            react_1.default.createElement(Save_1.default, { color: buttonActivation.create ? 'primary' : 'disabled' }))))
                        : (react_1.default.createElement(ButtonComponent_1.default, { color: 'primary', disabled: !buttonActivation.create, onClick: function () { return props.onClick && props.onClick(props.entity, CrudeAction.create); }, text: t('crude:create') })))))));
};
exports.default = DataEditButtons;
